import classnames from 'classnames';
import React, { CSSProperties } from 'react';
import { SelectionType } from '../enums/SelectionType.enum';
import { useProductSelection } from '../hooks/useProductSelection';
import { ViewProduct } from '../models/ViewProduct.model';
import { Denomination } from '../product_detail/components/denomination.enum';
import styles from './GiftCardDenominationSwatches.module.scss';

interface Props {
  product: ViewProduct;
  selectionType: SelectionType;
  selectionKey: string;
  style: CSSProperties;
}

export const GiftCardDenominationSwatches: React.FC<Props> = ({ product, selectionType, selectionKey, style }) => {
  const { denomination, setDenomination } = useProductSelection(selectionType, selectionKey);

  if (!product.denominations?.length) return <></>;

  return (
    <div className={styles.denominationSwatchContainer} style={style}>
      <div className={styles.denominationSwatchWrapper}>
        {product.denominations.map((d, i) => (
          <DenominationSwatch key={i} active={denomination === d} activate={() => setDenomination(d)} denomination={d} available={true} />
        ))}
      </div>
      <div className={styles.textContainer}>
        <span style={denomination ? {} : { opacity: 0 }}>Value: </span>
        <span className={styles.sizeName}>{denomination?.toUpperCase()}</span>
      </div>
    </div>
  );
};

interface DenominationSwatchProps {
  denomination: Denomination;
  active: boolean;
  available: boolean;
  activate: (denomination: Denomination) => void;
  style?: CSSProperties;
}

const DenominationSwatch: React.FC<DenominationSwatchProps> = ({ denomination, active, activate, style }) => {
  return (
    <button
      className={classnames(styles.swatch, { [styles.selected]: active })}
      role="radio"
      aria-label={denomination}
      aria-checked={active ? 'true' : 'false'}
      onClick={() => !active && activate(denomination)}
      style={style}
    >
      {denomination.replace('.00', '')}
    </button>
  );
};

export default GiftCardDenominationSwatches;
